import * as React from 'react';
import {DateRange} from '../../stores/TimeIntervalStore';
import DateRangeSelector from '../../views/DateRangeSelector';
import {stylesheet} from 'typestyle';
import {TProvider} from '../../i18n/i18n';
import {DateRangeWithId, Report, TextVariableWithValue} from '../types/Report';
import {observer} from 'mobx-react';
import {LightGreyColor} from '../../styles/colors';

interface DownloadReportModalBodyProps {
    report: Report;
    dateRangesWithId: DateRangeWithId[];
    updateDateRangeRegister: (idNamedDateRange: string, dateRange: DateRange) => void;
    variablesWithValue: TextVariableWithValue[];
    updateTextVariableValue: (textVariableName: string, textVariableValue: string) => void;
}

export const DownloadReportModalBody = observer(
    ({report, dateRangesWithId, updateDateRangeRegister, variablesWithValue, updateTextVariableValue}: DownloadReportModalBodyProps) => {
        return (
            <div>
                {report.dates.map((namedDateRange) => {
                    const dateRangeForId = dateRangesWithId.find((dateRangeWithId) => dateRangeWithId.id === namedDateRange.id);
                    return (
                        <div className={bodyCss.dateRangeContainer} key={namedDateRange.id}>
                            <div className={bodyCss.diagramTitle}>{namedDateRange.name}</div>
                            <DateRangeSelector
                                showRelativeDateRangeButtons={true}
                                width="auto"
                                namePrefix="dashboard"
                                startDate={dateRangeForId ? dateRangeForId.dateRange.startDate : undefined}
                                endDate={dateRangeForId ? dateRangeForId.dateRange.endDate : undefined}
                                onDatesChange={(dateRange) => updateDateRangeRegister(namedDateRange.id, dateRange)}
                            />
                        </div>
                    );
                })}
                {variablesWithValue.map((variableWithValue) => {
                    return (
                        <div key={variableWithValue.name} className={bodyCss.textVariableContainer}>
                            <div className={bodyCss.diagramTitle}>{variableWithValue.name}</div>
                            <div>
                                <TProvider>
                                    {(t) => (
                                        <input
                                            value={variableWithValue.value}
                                            onChange={(e) => updateTextVariableValue(variableWithValue.name, e.currentTarget.value)}
                                            className={bodyCss.variableInput}
                                            type="text"
                                            placeholder={t('report:textBlockActions.variable')}
                                        />
                                    )}
                                </TProvider>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
);

const bodyCss = stylesheet({
    textVariableContainer: {
        marginBottom: 15,
    },
    variableInput: {
        width: '100%',
        border: '1px solid ' + LightGreyColor,
        borderRadius: 2,
        padding: 4,
    },
    dateRangeContainer: {
        marginBottom: 15,
    },
    diagramTitle: {
        fontWeight: 'bold',
        fontSize: 12,
        marginBottom: 5,
    },
});



// WEBPACK FOOTER //
// ./src/report/views/DownloadReportModalBody.tsx